class ListController {
  /* @ngInject */
  constructor($http, $stateParams, $state, $window, $scope, $timeout, Session, CASE_BUCKETS, urls) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$window = $window;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.Session = Session;
    this.buckets = CASE_BUCKETS;
    this.urls = urls;
    this.isStateFilterOpen = false;
    this.selectAllCaseCheckbox = false;
  }

  $onInit() {
    // testing
    this.showBetaFeat = this.Session.read('showBetaFeat') === 'true';
    this.selectedCases = {};

    this.user = this.Session.read('userinfo') || {};
    this.states = Object.values(this.Session.read('states'));
    this.buckets = this.buckets[this.user.client.type]
      .filter(v => !['CLOSED'].includes(v));

    this.isVendor = this.user.client.type === 'VENDOR';
    this.isCustomer = this.user.client.type === 'CUSTOMER';
    this.ui = { lazyLoad: false, loading: true };
    this.selectedStateIds = [];

    this.params = {
      bucket: this.isVendor ? 'NEW' : 'PENDING',
      offset: 0,
      limit: 20,
    };

    this.$http.get('/case/category', { params: { allocatedTemplates: true } })
      .then(({ data }) => {
        this.clients = data;
      });

    const { bucket, categoryId, clientId } = this.$stateParams;

    this.getData({ bucket, categoryId, clientId });
  }

  getData(params = {}) {
    this.ui.loading = true;
    this.isStateFilterOpen = false;
    this.selectAllCaseCheckbox = false;
    this.selectedCases = {};
    const { categoryId, bucket, clientId, stateIds = [] } = params;

    if (bucket) Object.assign(this.params, { bucket });
    if (categoryId) Object.assign(this.params, { categoryId });
    if (clientId) Object.assign(this.params, { clientId });

    this.selectedStateIds = stateIds;

    Object.assign(this.params, { stateIds });
    Object.assign(this.params, { searchText: this.searchText });

    Object.assign(this.params, { limit: 20, offset: 0 });

    this.$state.go('.', this.params, { notify: false });

    this.$http.get('/case/bucket', { params: this.params })
      .then(({ data }) => {
        this.caseBuckets = data;
      });

    this.list = [];
    this.$http.get('/case', { params: this.params })
      .then(({ data }) => {
        this.list = data;
        this.params.offset = this.params.offset + data.length;
        this.ui.lazyLoad = data.length === this.params.limit;
      })
      .finally(() => {
        this.ui.loading = false;
      });
  }

  getLazyLoadedCases() {
    if (!this.ui.lazyLoad || this.ui.loading) return;

    this.ui.loading = true;

    Object.assign(this.params, { searchText: this.searchText });

    this.$http.get('/case', { params: this.params })
      .then(({ data }) => {
        this.list = this.list.concat(data);
        this.params.offset = this.params.offset + data.length;
        this.ui.lazyLoad = data.length === this.params.limit;
      })
      .finally(() => {
        this.ui.loading = false;
      });
  }

  getDisplayName(bucket) {
    return `${bucket.replace(/_/g, ' ')} (${(this.caseBuckets && this.caseBuckets[bucket]) || 0})`;
  }

  filterDataByStateIds() {
    this.getData({ stateIds: this.selectedStateIds });
  }

  toggleCaseCheckbox(caseId) {
    if (!this.selectedCases[caseId]) {
      delete this.selectedCases[caseId];
    }
  }

  toggleSelectAllCaseCheckbox() {
    if (this.selectedCasesLength()) {
      this.selectAllCaseCheckbox = false;
      Object.keys(this.selectedCases).forEach(caseId => {
        delete this.selectedCases[caseId];
      });
    } else {
      this.selectAllCaseCheckbox = true;
      this.list.forEach(caseData => {
        this.selectedCases[caseData.id] = true;
      });
    }
  }

  bulkDownloadOfLatestReports() {
    const caseIdsToDownload = Object.keys(this.selectedCases).join(',');

    if (caseIdsToDownload) {
      this.$window.open(
        `${this.urls.API_SERVER}/api/case/bulkDownload/latestReports?access_token=${
          this.Session.accessToken}&caseIds=${caseIdsToDownload}`,
        '_blank'
      );

      this.selectedCases = {};
    }
  }

  selectedCasesLength() {
    return Object.keys(this.selectedCases).length;
  }
}

export default ListController;



// WEBPACK FOOTER //
// ./client/app/cases/list/list.controller.js